export default "__VITE_ASSET__Bhquo7RQ__"